import React from "react";
import { Modal } from "@mui/material";
import { Close } from "@mui/icons-material";
import { useRecoilState } from "recoil";
import { useDeviceHook } from "../../utils/hooks/useDeviceHook";
import { Button } from "../shared/Button/Button";

import {
  FetalAddOnModalWrapper,
  DraftInfoModalMessage,
} from "../Grid/Grid.styles";
import { NewReqCFModalTitle } from "./NewRequisition.styles";
import { currentNewRequisitionEdit } from "../../recoil/atoms";

export const NewRequisitionFetalRiskModal: React.FC<{
  open: boolean;
  onClose: () => void;
  onContinueWithout: () => void;
  onAddCarrierScreen?: () => void;
}> = ({ open, onClose, onContinueWithout, onAddCarrierScreen }) => {
  const { deviceType } = useDeviceHook();

  const [newRequisition, setNewRequisition] = useRecoilState(
    currentNewRequisitionEdit,
  );

  return (
    <Modal
      open={open}
      onClose={onClose}
      style={{
        alignItems: "center",
        justifyContent: "center",
        display: "flex",
      }}
    >
      <FetalAddOnModalWrapper deviceType={deviceType}>
        <NewReqCFModalTitle>
          Would you also like to order the Carrier Screen as well?
          <span onClick={onClose}>
            <Close />
          </span>
        </NewReqCFModalTitle>
        <DraftInfoModalMessage
          style={{ margin: "24px 25px 0", paddingRight: 0 }}
        >
          Only Aneuploidy is currently selected. If you would like to also
          include Carrier Screen please select below:
        </DraftInfoModalMessage>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "12px",
            padding: "24px 25px",
          }}
        >
          <Button
            label="add carrier screen"
            onClick={() => {
              setNewRequisition({
                ...newRequisition,
                requisitionForm: {
                  ...newRequisition.requisitionForm,
                  carrierScreen: true,
                  O285_carrier: true,
                },
              });
              (onAddCarrierScreen ?? onClose)();
            }}
            size="small"
          />
          <Button
            label="continue without"
            onClick={onContinueWithout}
            size="small"
            backgroundColor="white"
            textColor="redMedium"
          />
        </div>
      </FetalAddOnModalWrapper>
    </Modal>
  );
};
